module.exports = __webpack_public_path__ + "img/7-3.c02dc231.png";